import React from 'react';

const RoundIcon = (props) => {
  const { action, selected, img } = props
  let classes = "round-icon";
  if (selected) { classes += " selected"}
  return (
    <div onClick={() => action()} className={classes} style={{ background: 'url(' + img + ')' }}>
      <img src={img} className="round-icon-img"/>
    </div>
  )
}

export default RoundIcon